export default __webpack_public_path__ + "static/media/life-nft-720p.e08759bb.mp4";